export interface ICustomerReport {
  id: number;
  code: string;
  name: string;
}
